import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import AbstractFopContainer from '../AbstractFopContainer';
import FopList from 'apps/fops/containers/FopList';
import { componentTypes } from 'apps/analytics';
import { VIEW_TYPE_PREFERENCE_LIST } from 'apps/catalogue/actions/catalogue';
import FeaturedFopElementsFactory from 'apps/fops/components/fopElementsFactories/FeaturedFopElementsFactory';
import HorizontalScrollList from 'apps/catalogue/components/HorizontalScrollList';
import { FopContainerBasketItems, FopContainerViewPreferenceShape, FopContainerVisibleFops } from '../../types';

export default class ProductsCarouselSavingHubPage extends AbstractFopContainer {
  static propTypes = {
    afterBasketQuantityChange: PropTypes.func,
    basketItems: FopContainerBasketItems,
    dispatch: PropTypes.func.isRequired,
    fopViewPreference: FopContainerViewPreferenceShape,
    gtmPageType: PropTypes.string,
    maxDisplayFops: PropTypes.number,
    productsBySku: PropTypes.object.isRequired,
    productWarnings: PropTypes.objectOf(PropTypes.array),
    quickMenuExpanded: PropTypes.object,
    title: PropTypes.string,
    shoppingListsModal: PropTypes.bool,
    subscriptionsBySku: PropTypes.object,
    visibleFops: FopContainerVisibleFops,
    sectionTitle: PropTypes.string.isRequired,
    sectionText: PropTypes.string.isRequired,
  };

  render() {
    const {
      basketItems,
      productBySkuCarousel: { sections },
      productsBySku,
      productWarnings,
      sectionTitle,
      sectionText,
    } = this.props;

    const totalFops = get(sections[0], 'fops.length', -1);
    const gtmPageType = 'Recommended items';
    const fopType = componentTypes.FOP_REGULAR;
    const featuredMainClass = 'featured-items';
    const YshFopElementsFactory = new FeaturedFopElementsFactory({
      basketItems,
      onQuantitySubmit: this.onQuantitySubmit,
      productWarnings,
      productsBySku,
      viewTypePreference: VIEW_TYPE_PREFERENCE_LIST,
    });
    return (
<section className="your-saving-hub-carousel-section">
  <div className="your-saving-hub-carousel">
    <h2>{sectionTitle}</h2>
    <p>{sectionText}</p>
    <section className={`${featuredMainClass}`}>
      <div className={`${featuredMainClass}-content`}>
        <div className="js-productCarouselFops">
          <div className="carousel-wrapper">
            <HorizontalScrollList
              mainClassName={featuredMainClass}
              arrowLeft={<span className="icon icon__chevron-left featured-items__arrow" />}
              arrowRight={<span className="icon icon__chevron-right featured-items__arrow" />}
              ref={(ref) => { this.horizontalScroll = ref; }}
            >
              <FopList
                sections={sections}
                maxDisplayFops={totalFops}
                totalFops={totalFops}
                productWarnings={productWarnings}
                fopElementsFactory={YshFopElementsFactory}
                fopType={fopType}
                productsBySku={productsBySku}
                gtmPageType={gtmPageType}
              />
            </HorizontalScrollList>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>
    );
  }
}

